import React from "react";
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import reactImage from "../assets/react.png";
import bootstrap from "../assets/Bootstrap_logo.svg.png";
import git from "../assets/git.png";
import github from "../assets/github.png";
import tailwind from "../assets/tailwind.png";
import { motion } from "framer-motion";
const Experience = () => {
    const techs = [
        {
          id: 1,
          src: html,
          title: "HTML",
          style: "shadow-orange-500",
        },
        {
          id: 2,
          src: css,
          title: "CSS",
          style: "shadow-blue-500",
        },
        {
          id: 3,
          src: javascript,
          title: "JavaScript",
          style: "shadow-yellow-500",
        },
        {
          id: 4,
          src: reactImage,
          title: "React",
          style: "shadow-blue-600",
        },
        {
          id: 5,
          src: bootstrap,
          title: "Bootstrap",
          style: "shadow-[#7952b3]",
        },
        {
          id: 6,
          src: tailwind,
          title: "Tailwind",
          style: "shadow-sky-400",
        },
        {
          id: 7,
          src: git,
          title: "Git",
          style: "shadow-[#F05032]",
        },
        {
          id: 8,
          src: github,
          title: "GitHub",
          style: "shadow-gray-400",
        }
      ];
  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-300 to-gray-200 dark:bg-gradient-to-b dark:from-gray-800 dark:to-gray-700 w-full h-fit scroll-mt-22"
    >
      <motion.div initial={{ scale: 0 }}
    whileInView={{ scale: 1 }}
    transition={{ duration: 1 }}
    viewport={{ once: true, amount: 0.35 }} className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full  h-fit">
        <div>
          <p className="text-4xl font-bold border-b-4  border-gray-800 text-gray-800 dark:text-gray-200 dark:border-gray-200 p-2 inline">
            Experience
          </p>
          <p className="py-6  text-gray-800 dark:text-gray-200">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8  px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4  text-gray-800 dark:text-gray-200">{title}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  )
}

export default Experience;